<template>
  <div>
    <h1 class="title text-center">Order Details</h1>

    <div
      v-if="is_loading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <b-container v-else>
      <b-row class="border-bottom mt-4">
        <b-col cols="2"><h5>Image</h5></b-col>

        <b-col cols="4"><h5>Item Details</h5></b-col>

        <b-col cols="2"><h5>Quantity</h5></b-col>

        <b-col cols="2"><h5>Price</h5></b-col>

        <b-col cols="2"><h5>Total</h5></b-col>
      </b-row>

      <b-row
        v-for="(order_item, index) in order.attributes.order_items.data"
        :key="order_item.id"
        class="py-2 border-bottom font-lighter order-item-row"
        @click="show_details_modal(index)"
      >
        <b-col cols="2">
          <b-img-lazy blank="true" :blank-src="require('../assets/images/eclipse.gif')" :src="order_item.attributes.menu_item_image_url" alt="Image 1"></b-img-lazy>
        </b-col>

        <b-col cols="4">
          {{ order_item.attributes.menu_item_name }}
        </b-col>

        <b-col cols="2">{{ order_item.attributes.quantity }}</b-col>

        <b-col cols="2">{{ order_item.attributes.price }}</b-col>

        <b-col cols="2">$ {{ order_item.attributes.total }}</b-col>
      </b-row>
    </b-container>

    <b-modal ref="order_item_modal" hide-footer title="Order Item Details">
      <b-container v-if="index > -1">
        <table
          v-if="order.attributes.order_items.data[index].attributes.order_item_options.data.length > 0"
          class="table table-borderless table-sm w-100"
        >
          <thead>
            <tr class="d-flex border-bottom">
              <th class="col-md-6">Option</th>
              <th class="col-md-6">Price</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="order_item_option in order.attributes.order_items.data[index].attributes.order_item_options.data"
              :key="order_item_option.id"
              class="d-flex border-bottom"
            >
              <td class="col-md-6">{{ capitalize(order_item_option.attributes.option_type_name) }} - {{ capitalize(order_item_option.attributes.menu_option_name) }}</td>
              <td class="col-md-6">$ {{ order_item_option.attributes.price }}</td>
            </tr>
          </tbody>
          <em class="text-secondary table-detail">Your selected options.</em>
        </table>

        <table
          v-if="order.attributes.order_items.data[index].attributes.order_item_add_ons.data.length > 0"
          class="table table-borderless table-sm w-100"
        >
          <thead>
            <tr class="d-flex border-bottom">
              <th class="col-6">Add Ons</th>
              <th class="col-6">Price</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="order_item_add_on in order.attributes.order_items.data[index].attributes.order_item_add_ons.data"
              :key="order_item_add_on.id"
              class="d-flex border-bottom"
            >
              <td class="col-6">{{ capitalize(order_item_add_on.attributes.name) }}</td>
              <td class="col-6">$ {{ order_item_add_on.attributes.price }}</td>
            </tr>
          </tbody>
          <em class="text-secondary table-detail">Your selected add ons.</em>
        </table>

        <table class="table table-borderless table-sm">
          <tbody class="table-bordered">
            <tr>
              <td>Add On's Total</td>
              <td>$ {{ order.attributes.order_items.data[index].attributes.add_ons_total }}</td>
            </tr>

            <tr class="border-top" style="background-color: #E8E8E8;">
              <td><i>Grand Total</i></td>
              <td><i>$ {{ order.attributes.order_items.data[index].attributes.total }}</i></td>
            </tr>
          </tbody>
          <em class="text-secondary table-detail">Total billing details.</em>
        </table>

        <b-button
          squared
          variant="outline-primary"
          class="float-right col-md-3"
          @click="hide_modal"
        >Close</b-button>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { getOrder } from '../store/api'

export default {
  data() {
    return {
      order: {},
      index: -1,
      is_loading: true,
    }
  },

  created() {
    getOrder(this.$route.params.id)
      .then(response => {
        this.order = response.data
        this.is_loading = false
      })
  },

  methods: {
    show_details_modal(index) {
      this.index = index
      this.$refs['order_item_modal'].show()
    },
    hide_modal() {
      this.index = -1
      this.$refs['order_item_modal'].hide()
    },
    capitalize(name) {
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
  },
}
</script>

<style scoped>
  li {
    list-style-type: none;
  }
  img {
    width: 80px;
    height: 80px;
    object-fit: cover;
  }
  .order-item-row {
    cursor: pointer;
  }
  .order-item-row:hover {
    background-color: #e9ecef;
  }
  .btn-outline-primary {
    color: #5663FF;
    border-color: #5663FF;
    background-color: white;
    box-shadow: none;
  }
  .btn-outline-primary:hover {
    color: white;
    border-color: #5663FF;
    background-color: #5663FF;
  }
  .table-detail {
    font-size: 12px;
  }
</style>
